import 'react-datepicker/dist/react-datepicker.css'

import { Button, Flex, Text } from '@chakra-ui/react'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import _ from 'lodash'

import Icon from 'src/components/widgets/Icon/Icon'

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

type DatePickerHeaderProps = {
  date: Date
  decreaseMonth(): void
  increaseMonth(): void
  prevMonthButtonDisabled: boolean
  nextMonthButtonDisabled: boolean
}

const DatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: DatePickerHeaderProps) => {
  return (
    <Flex justifyContent="space-between">
      <Button
        variant="ghost"
        padding={0}
        onClick={decreaseMonth}
        isDisabled={prevMonthButtonDisabled}
      >
        <Icon icon={faChevronLeft} color="onyx" />
      </Button>
      <Flex>
        <Text className="body-small-emphasis">
          {months[date.getMonth()]}&nbsp;
        </Text>
        <Text className="body-small-emphasis">{date.getFullYear()}</Text>
      </Flex>
      <Button
        variant="ghost"
        padding={0}
        onClick={increaseMonth}
        isDisabled={nextMonthButtonDisabled}
      >
        <Icon icon={faChevronRight} color="onyx" />
      </Button>
    </Flex>
  )
}

export default DatePickerHeader
